/** Only this account can open Reports / Contact Us inbox. */
export const REPORTS_ADMIN_EMAIL = "zzaben332007@gmail.com";

export function isReportsAdmin(email?: string | null): boolean {
  let configured = REPORTS_ADMIN_EMAIL;
  try {
    if (typeof process !== "undefined" && process.env?.REPORTS_ADMIN_EMAIL) {
      configured = process.env.REPORTS_ADMIN_EMAIL.trim() || configured;
    }
  } catch {
    /* ignore */
  }
  try {
    const viteEnv = (import.meta as ImportMeta & {
      env?: { VITE_REPORTS_ADMIN_EMAIL?: string };
    }).env?.VITE_REPORTS_ADMIN_EMAIL;
    if (viteEnv?.trim()) configured = viteEnv.trim();
  } catch {
    /* ignore */
  }
  return (
    String(email || "").trim().toLowerCase() === configured.toLowerCase()
  );
}
